import { useState } from "react";
import axios from "axios";
import { ArrowLeft, ArrowRight, Loader2, Sparkles } from "lucide-react";
import { toast } from "sonner";
import { BrandHeader } from "@/components/BrandHeader";
import { QuestionCard } from "@/components/QuestionCard";
import { API } from "@/App";

export default function Assessment({ questions, answers, setAnswers, index, setIndex, onExit, onComplete }) {
  const [submitting, setSubmitting] = useState(false);
  if (!questions) {
    return <div className="min-h-screen grid place-items-center"><Loader2 className="h-8 w-8 animate-spin text-[#800534]" data-testid="questions-loading" /></div>;
  }
  const q = questions[index];
  const total = questions.length;
  const isLast = index === total - 1;
  const answered = answers[q.id] !== undefined;
  const progress = Math.round((Object.keys(answers).length / total) * 100);

  const next = async () => {
    if (!answered) {
      toast.error("Please choose the answer that feels most true for you.");
      return;
    }
    if (!isLast) return setIndex(index + 1);
    const missing = questions.findIndex((x) => answers[x.id] === undefined);
    if (missing >= 0) {
      toast.error("A question still needs your answer.");
      return setIndex(missing);
    }
    setSubmitting(true);
    try {
      const r = await axios.post(`${API}/assess`, { answers });
      onComplete(r.data);
    } catch {
      toast.error("We couldn't calculate your results. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  const back = () => (index === 0 ? onExit() : setIndex(index - 1));

  return (
    <div data-testid="assessment-screen" className="min-h-screen flex flex-col">
      <BrandHeader right={<span className="text-sm text-[#6E4450]" data-testid="question-counter">{index + 1} of {total}</span>} />
      <div className="fea-progress-wrap">
        <div className="fea-progress"><div className="fea-progress-bar" style={{ width: `${progress}%` }} data-testid="progress-bar" /></div>
      </div>
      <main className="fea-container max-w-3xl w-full flex-1 pt-8 sm:pt-12">
        <div key={q.id} className="fea-rise">
          <QuestionCard q={q} value={answers[q.id]} onSelect={(v) => setAnswers({ ...answers, [q.id]: v })} />
        </div>
        <div className="flex items-center justify-between gap-4 mt-8">
          <button onClick={back} className="fea-btn-ghost" data-testid="back-button">
            <ArrowLeft className="h-4 w-4" /> Back
          </button>
          <button onClick={next} disabled={submitting} className={`fea-btn ${!answered ? "opacity-60" : ""}`} data-testid={isLast ? "see-results-button" : "next-button"}>
            {submitting ? <Loader2 className="h-5 w-5 animate-spin" /> : isLast ? <Sparkles className="h-5 w-5" /> : null}
            {isLast ? "See My Results" : "Next"}
            {!isLast && <ArrowRight className="h-5 w-5" />}
          </button>
        </div>
      </main>
    </div>
  );
}
